import React from "react";
import styles from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.shell}>

        {/* Left — Brand */}
        <section className={styles.brand}>
          <h2>Happy Horizon</h2>
          <p>
            A thoughtfully designed learning environment where children
            grow with confidence, creativity, and care.
          </p>
        </section>

        {/* Center — Address */}
        <section className={styles.address}>
          <h4>Address</h4>
          <address>
           F71, Plot No: 273<br />
           2nd Main Rd, Block F,<br />
           Annanagar East,<br />
            Chennai, Tamil Nadu 600102<br />
            India
          </address>
        </section>

        {/* Right — Contact */}
        <section className={styles.contact}>
           <a
            href="https://www.instagram.com/happyhorizon.chennai"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.social}
            aria-label="Instagram"
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 2H17C19.761 2 22 4.239 22 7V17C22 19.761 19.761 22 17 22H7C4.239 22 2 19.761 2 17V7C2 4.239 4.239 2 7 2Z"
                stroke="currentColor"
                strokeWidth="2"
              />
              <circle
                cx="12"
                cy="12"
                r="3.5"
                stroke="currentColor"
                strokeWidth="2"
              />
              <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
            </svg>
            <span>Instagram</span>
          </a>
          <h4>Contact</h4>
          <a href="tel:+91 9384018500">+91 9384018500</a>
          <a href="mailto:Globetots1@gmail.com">Globetots1@gmail.com</a>
          
          <a
            className={styles.map}
            href="https://maps.app.goo.gl/WYoABo7P7ZVNKAra6"
            target="_blank"
            rel="noopener noreferrer"
          >
            View on Google Maps
          </a>
          
        </section>

      </div>

      {/* Bottom */}
      <div className={styles.bottom}>
        © {new Date().getFullYear()} Happy Horizon. All rights reserved.
      </div>
    </footer>
  );
}
